import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { sanityClient } from "../lib/sanityClient";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";

function CarImportationPage() {
  const [consultations, setConsultations] = useState([]);
  const [loading, setLoading] = useState(true);
  const { lang } = useOutletContext();
  const { t } = useTranslation();

  useEffect(() => {
    const fetchConsultations = async () => {
      try {
        const query = `*[_type == "importConsultation"]{
          _id, title, description, processSteps, fees
        }`;
        const fetchedConsultations = await sanityClient.fetch(query);
        setConsultations(fetchedConsultations);
      } catch (error) {
        console.error("Error fetching import consultations:", error);
      }
      setLoading(false);
    };

    fetchConsultations();
  }, []);

  const getLocalized = (obj) => obj?.[lang] || obj?.en;

  return (
    <div className="container mx-auto px-4 py-8">
      <Helmet>
        <title>{t("importConsultation.pageTitle")}</title>
        <meta name="description" content={t("importConsultation.pageDescription")} />
        <link rel="canonical" href='https://237mechanic.com/cm/en/car-importation-consultation' />

      </Helmet>

      <h1 className="text-3xl font-bold text-center mb-6">
        {t("importConsultation.pageTitle")}
      </h1>
      <p className="text-lg text-gray-600 text-center mb-8">
        {t("importConsultation.pageDescription")}
      </p>

      {loading ? (
        <p className="text-center text-gray-500">{t("importConsultation.loading")}</p>
      ) : consultations.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {consultations.map((consultation) => (
            <div key={consultation._id} className="border rounded-lg p-4 shadow-lg">
              <h2 className="text-xl font-semibold">{getLocalized(consultation.title)}</h2>
              <p className="text-gray-600 mt-2">{getLocalized(consultation.description)}</p>

              <h3 className="font-semibold mt-4">{t("importConsultation.steps")}:</h3>
              <ul className="list-disc list-inside text-gray-700">
                {consultation.processSteps?.map((step, index) => (
                  <li key={index}>{getLocalized(step)}</li>
                ))}
              </ul>

              <p className="text-blue-600 font-medium mt-4">
                {t("importConsultation.fees")}: CFA {consultation.fees.toLocaleString()}
              </p>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-center text-gray-500">
          {t("importConsultation.noConsultations")}
        </p>
      )}
    </div>
  );
}

export default CarImportationPage;
